// Enrollment form: bank name auto-fill from account code.
$(document).ready(function() {
	var $form = $(".js-enrollment-form");
	if (!$form.length) { return; }

	var codes = $form.data("bankCodes") || {};
	var $account = $form.find("[data-bank-account]");
	var $bankName = $form.find("[data-bank-name]");

	function bankNameFromAccount() {
		var code = ($account.val() || "").split("/").pop().trim();
		var name = codes[code];
		if (!name) { return; }
		if ($bankName.val() === "" || $bankName.data("autofilled")) {
			$bankName.val(name).data("autofilled", true);
		}
	}

	$bankName.on("input", function() { $(this).data("autofilled", false); });
	$account.on("input change", bankNameFromAccount);
});
